import { downloadResult, fetchResults } from "actions/jobs";
import RequireData from "hooks/RequireData";
import React from "react";
import { ListGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import fetchResultsStatusSelector from "selectors/fetchResultStatus";
import resultsSelector from "selectors/results";
import { colorclassForResult, statusTextForResult } from "utils/resultStatus";

interface Props {
    job: sage.model.IJob;
}

const JobDetail2InfoResultsRow: React.FC<Props> = ({ job }) => {
    const dispatch = useDispatch();

    const [results, resultsStatus] = RequireData(
        resultsSelector(job.id),
        fetchResultsStatusSelector(job.id),
        fetchResults(job.id)
    );

    const bestResult = React.useMemo(() => {
        if (!results) {
            return null;
        }
        for (const r of results) {
            if (r.state === "FINISHED") {
                return r;
            }
        }
        for (const r of results) {
            if (r.state === "ASSEMBLING") {
                return r;
            }
        }
        return results[0];
    }, [results]);

    React.useEffect(() => {
        if (
            job.job_state !== "FINISHED" ||
            (bestResult && bestResult.state === "FINISHED")
        ) {
            return;
        }
        const interval = setInterval(() => {
            dispatch(fetchResults(job.id));
        }, 5000);
        return () => clearInterval(interval);
    }, [dispatch, job.job_state, job.id, bestResult]);

    const download = React.useCallback(() => {
        if (bestResult && bestResult.state === "FINISHED") {
            dispatch(downloadResult(bestResult.id));
        }
    }, [bestResult, dispatch]);

    if (resultsStatus === "loading") {
        return null;
    }

    if (job.job_state !== "FINISHED") {
        return (
            <ListGroup.Item>
                Job not finished. Result will be created once finished.
            </ListGroup.Item>
        );
    }

    if (!bestResult) {
        return (
            <ListGroup.Item variant="primary">
                Enqueing result task...
            </ListGroup.Item>
        );
    }

    return (
        <ListGroup.Item
            action={bestResult.state === "FINISHED"}
            onClick={download}
            variant={colorclassForResult(bestResult)}
        >
            {statusTextForResult(bestResult)}
            {bestResult.state === "FINISHED" && <b> Click to download</b>}
        </ListGroup.Item>
    );
};

export default JobDetail2InfoResultsRow;
